import type { ImageManifest } from './responsiveImages.mjs';

// Необязательный glob позволяет проверять типы на чистом клоне без сгенерированного JSON.
// Перед dev/build генератор создаёт файл; Vite встраивает его и в клиент, и в пререндер.
const manifests = import.meta.glob<ImageManifest>('./generated/*.json', {
  eager: true,
  import: 'default',
});

const IMAGE_MANIFEST: ImageManifest = manifests['./generated/manifest.json'] ?? {};

export const getImageEntry = (src: string) => IMAGE_MANIFEST[src];
